import { styled } from "@mui/material/styles";
import { useWidth } from "custom-hooks/use-width.hook";
import Link from "next/link";
import React from "react";
import Button from "@components/Button";
import { TitleThickThin } from "@components/titles";
import Typography from "@components/Typography";
import { CPagesPath } from "shared/models/const/pages-path";
import { useTranslations } from "next-intl";
import { Avatar } from "@mui/material";

const FranchiseContainer = styled("article")(({ theme }) => ({
  paddingTop: "200px",
  height: "800px",
  backgroundColor: "#fff",
  backgroundPosition: "center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundImage: 'url("/images/v2/pic/image-02.jpeg")',
  [theme.breakpoints.down("md")]: {
    backgroundImage: "none !important",
    paddingTop: "100px",
    paddingBottom: "40px",
    height: "auto",
  },
  [theme.breakpoints.down("sm")]: {
    paddingTop: "20px",
  },
}));

const FranchiseDetails = styled("div")(({ theme }) => ({
  padding: "0px 107px",
  maxWidth: "618px",
  marginLeft: "auto",
  fontWeight: 400,
  color: "var(--color-brand-grey-main)",
  fontSize: "0.938rem",
  [theme.breakpoints.down("lg")]: {
    padding: "0px 55px",
    maxWidth: "415px",
  },
  [theme.breakpoints.down("md")]: {
    marginRight: "auto",
    padding: "0px 0px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "0px 20px",
  },
}));

const TextInfo = styled("p")(({ theme }) => ({
  textShadow: "1px 0px 0.5px #fffa",
  color: "var(--color-text-black)",
  fontWeight: 400,
  fontSize: "1rem",
  margin: "15px 0px",
  fontFamily: "var(--font-family)",
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
  },
}));

const ContentBtn = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  marginTop: "1.8rem",
  "& a": {
    minWidth: "260px",
    margin: "0.5rem 0px",
  },
});

function FranchisesHomeSection() {
  const width = useWidth();
  const translation = useTranslations("home.franchise");

  const franchiseTitle = translation("title") || "";

  const [title, ...rest] = franchiseTitle.split(" ");

  return (
    <FranchiseContainer className="franchise">
      <div>
        <FranchiseDetails className="franchise__details">
          <Avatar
            src="/images/v2/logos/5.png"
            sx={{
              width: "100%",
              maxWidth: "400px",
              height: "140px",
              margin: "0 auto",
              marginBottom: "-1.5rem",
              marginLeft: "-10px",
              objectFit: "contain",
            }}
            variant="square"
          />
          <TextInfo>{translation("network")}</TextInfo>

          <TextInfo>{translation("advantage")}</TextInfo>

          <TextInfo>{translation("develop")}</TextInfo>
          <ContentBtn className="franchise__btn">
            <Link href={CPagesPath.es.franchises}>
              <Button component="a" bg="--color-brand-red-tertiary">
                {translation("openFranchise")}
              </Button>
            </Link>
            <Link href={CPagesPath.es.join}>
              <Button component="a" bg="--color-brand-red-main">
                {translation("joinUs")}
              </Button>
            </Link>
          </ContentBtn>
        </FranchiseDetails>
      </div>
    </FranchiseContainer>
  );
}

export default FranchisesHomeSection;
